import { useHistory } from 'react-router-dom';

import { DateDomainService } from '@/domain/services';
import { SiteListResponse } from '@/services/Site/hooks/list/useSiteList';

const siteUrl = {
  key: 'siteUrl',
  label: 'サイトURL',
} as const;

export const tempHoursForm = {
  siteUrl,
} as const;

export const tempHourText = {
  key: 'temp_hour_text',
  label: '休業日・臨時営業時間',
} as const;

export const deliveryStores = {
  key: 'delivery_stores',
  label: '対象店舗',
} as const;

export type TempHourType = 'close' | 'open';
export const tempHourTypeToLabel: {
  [key in TempHourType]: string;
} = {
  close: '全日休業',
  open: '臨時営業時間',
} as const;

const parseTempHour = (
  tempHourDate: Date,
  tempHourHour: string,
  tempHourMin: string
): Date => {
  const dt = new Date(tempHourDate);
  dt.setHours(Number(tempHourHour));
  dt.setMinutes(Number(tempHourMin));
  return dt;
};

export const formatTempHour = (
  tempHourDate: Date,
  tempHourHour: string,
  tempHourMin: string
): string => {
  return DateDomainService.datetimeNoColonFormat(
    parseTempHour(tempHourDate, tempHourHour, tempHourMin)
  );
};

const tableColumns = [
  {
    ...tempHourText,
    width: '270px',
  },
  {
    ...deliveryStores,
    width: '200px',
  },
] as const;

export const TempHoursTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

export const determineSelectedSiteId = (
  sites: SiteListResponse[],
  history: ReturnType<typeof useHistory>
): string => {
  const queryParams = new URLSearchParams(history.location.search);
  const querySiteId = queryParams.get('site_id');
  for (const site of sites) {
    if (site.id === querySiteId) {
      return site.id;
    }
  }

  const selectedSiteId = sites[0].id;
  return selectedSiteId;
};
